/**
 * Ryan O'Dowd
 * 2018-11-05
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

type TPlatform = 'ios' | 'android' | 'web';
type TApp = {
  name: string,
  platforms: TPlatform[],
  link: string,

  image?: object,
  iconName?: string,
  verticalDividerAfter?: boolean,
  verticalDividerBefore?: boolean,
};

const apps = (i18n): TApp[] => [
  {
    name: 'Tibbits',
    platforms: ['web'] as TPlatform[],
    link: 'https://tibbits.me/',
    image: require('@assets/img/apps/tibbits.png'),
  },
  {
    name: 'Wrinkly',
    platforms: ['web'] as TPlatform[],
    link: 'https://wrink.ly/',
    image: require('@assets/img/apps/wrinkly.png'),
  },
  {
    verticalDividerAfter: true,
    name: 'Oakwood',
    platforms: ['ios', 'android', 'web'] as TPlatform[],
    link: 'https://oakwoodsc.com/',
    image: require('@assets/img/apps/oakwood.png'),
  },
  {
    name: 'Tibbits',
    platforms: ['ios'] as TPlatform[],
    link: 'https://itunes.apple.com/us/app/id1332548860?mt=8&ls=1',
    image: require('@assets/img/apps/tibbits.png'),
  },
  {
    name: 'Tibbits',
    platforms: ['android'] as TPlatform[],
    link: 'https://play.google.com/store/apps/details?id=com.oakwoodsc.tibbits',
    image: require('@assets/img/apps/tibbits.png'),
  },
  {
    name: 'Wrinkly',
    platforms: ['ios'] as TPlatform[],
    link: 'https://itunes.apple.com/us/app/id1615885499?mt=8&ls=1',
    image: require('@assets/img/apps/wrinkly.png'),
  },
  {
    name: 'Wrinkly',
    platforms: ['android'] as TPlatform[],
    link: 'https://play.google.com/store/apps/details?id=com.oakwoodsc.wrinkly',
    image: require('@assets/img/apps/wrinkly.png'),
  },
  {
    name: i18n('webApp'),
    platforms: ['ios', 'android'] as TPlatform[],
    link: 'https://wrink.ly/app',
    image: require('@assets/img/apps/wrinkly.png'),
  },
  {
    name: i18n('download'),
    platforms: ['web'] as TPlatform[],
    link: 'https://itunes.apple.com/us/app/id1615885499?mt=8&ls=1',
    iconName: 'apple',
  },
  {
    name: i18n('download'),
    platforms: ['web'] as TPlatform[],
    link: 'https://play.google.com/store/apps/details?id=com.oakwoodsc.wrinkly',
    iconName: 'android',
  },
  {
    verticalDividerBefore: true,
    name: i18n('legal'),
    platforms: ['ios', 'android', 'web'] as TPlatform[],
    link: 'https://oakwoodsc.com/#terms_and_privacy',
    iconName: 'scale-balance',
  },
].filter((app) => app.platforms.includes(Platform.OS as TPlatform));

export default apps;
